import { render, staticRenderFns } from "./pElecChoose.vue?vue&type=template&id=4a5ecd24"
import script from "./pElecChoose.vue?vue&type=script&lang=js"
export * from "./pElecChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports